<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "stressaako";
    let title = "Stressaako?";
    let author = "Iida";
    let blogDate = "11.12.2016";
    let titlePic = "stressi.jpg";
    let firstPara = "Viime aikoina on puhuttu paljon stressistä ja sen vaikutuksista. Pitkittyneellä stressireaktiolla on yhteys elimistön lievään " +
        "tulehdustilaan, joka voi johtaa monenlaisiin ongelmiin.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>Viime aikoina on puhuttu paljon stressistä ja sen vaikutuksista. Huoli on aiheellinen, 
                koska yhä useampi kärsii ylikuormittumisen oireista. Pitkittyneellä stressireaktiolla on yhteys 
                elimistön lievään tulehdustilaan, joka voi johtaa monenlaisiin ongelmiin. Ajattelin kirjoittaa 
                lyhyesti omasta kohtaamisestani liialliseen stressiin.</p>

            <p>Pari vuotta sitten olin loppu. Kaikki oli hyvin. Poikani näytti toipuvan täydellisesti edellisen kesän
                onnettomuudesta. Koiramme kävi varoittamatta häntä kasvoihin kiinni. Tilanne oli kaikinpuolin raskas.
                Ajattelin, että monet kestävät paljon pahempaakin. Olen verrannut muutenkin itseäni paljon muihin.
                Kärsin kaiken seurauksena plus synnynnäisenä ominaisuutena paniikkihäiriöstä, mikä on mielestäni täysin
                käsittämätöntä. Mielestäni monen ihmisen elämä on paljon haastavampaa kuin omani, eikä heidän
                elimistönsä virittäydy esimerkiksi kaupan kassalla äärimmäiseen hälytystilaan. Ymmärrys ei riittänyt,
                mutta silti en jaksanut. Päivittäin mietin, että miten ihmeessä muilla on voimia ja minulla ei.</p>

            <p>Kävin töissä, mutta jouduin muutaman kerran lähtemään ovelta takaisin kotiin. Selkäni kipeytyi, ja
                pyöräilymatkan jälkeen jalat pettivät. Siitä seurasi hirvittävä itku, joka ei tahtonut loppua millään.
                Odotin kesää ja lomaa. Pari päivää ennen loman alkua sairastuin vatsatautiin. Tauti helpotti, mutta
                elimistö ei toiminut. Ruoka ei maistunut, mutta maha turposi ja tuntui oudolta. Pelkäsin jo vatsahaavaa.
                Olo vain paheni, vaikka oli loma. Säikyin kaikkea, sydän hyppäsi kurkkuun naapurin lasten
                kiljahduksista. Säikähdystä seurasi itku. Reagoin kuin olisin ollut pommituksen keskellä. Kaikki äänet
                ja valot tuntuivat liian voimakkailta, niihin väsyi.</p>

            <p>Olen aina nauttinut liikunnasta, mutta tuolloin itku tuli niin lenkkipolulla kuin ruokapöydässäkin. Teki
                mieli potkia itsensä treenaamaan. Hirvittävä syyllisyyden tunne lamaannutti, vaikkei sille ollut mitään
                syytä. Häpesin tuntemuksiani: minun kuuluisi olla onnellinen. Oli täysin käsittämätöntä, että "ei mitään
                hätää -kroppa" löi hanskat tiskiin. Näin myöhemmin, useiden terapiakäyntien jälkeen olen tajunnut, että
                omaan elämääni mahtuu paljon tapahtumia, joiden myötä elimistöni stressaantuminen on ihan oikeutettua.
                Sitä vain sopeutuu kaikkeen, mitä elämässään kohtaa. Ihminen selviytyy uskomattomista koettelemuksista,
                meidän elimistö on suunniteltu niin.</p>

            <p>Stressi on meille ihmisille välttämätön keino selviytyä tiukoista ja vaarallisista tilanteista. Reaktio
                aktivoi sympaattisen hermoston, ja sitä kautta sydämen syke kiihtyy ja hengitys tihenee. Hetkellinen
                stressireaktio on meille hyödyllinen, koska se lisää elimistön toimintakykyä: lihaksisto aktivoituu, ja
                ajatus kirkastuu. Hetkellisessä stressitilanteessa kaikki suorittamisen kannalta epäoleellinen siirtyy
                taka-alalle, kuten kivut ja väsymys.</p>

            <p>Minulla tuo reaktio jäi päälle. Viime aikoina on puhuttu paljon liian stressin vaarallisuudesta, ja ihan
                syystä. Tässä tarkoitan nimen omaan stressireaktion pitkittynyttä muotoa. Se syntyy tilanteesta, jolloin
                meidän voimavaramme eivät riitä käsittelemään kaikkia vaatimuksia ja haasteita. Nämä haasteet voivat
                olla ulkoisia, kuten jokin onnettomuus. Voimme myös itse kuormittaa elimistöämme esimerkiksi unen
                puutteella, kiireellä, liialla liikunnalla jne. Voisi sanoa, että stressireaktio jää ikään kuin kytemään
                kehoomme, jolloin elimistön normaalit toiminnot kärsivät. Stressaantunut elimistö on ohjelmoitu hengissä
                selviämiseen. Ei ole ollenkaan kummallista, ettei voimavaroja silloin ole esimerkiksi
                immuunipuolustukselle tai lihasten kasvattamiselle. Ylikuormittunut keho on todella usein este
                kehitykselle.</p>

            <p>Monet kokevat, että liikunta on hyvä keino vähentää stressin oireita. Stressin ehkäisyyn sopii kaikki
                liikunta, josta seuraa hyvä ja virkistynyt olo. Pakonomainen liikunta tai liian kovatehoinen treeni
                kuitenkin pahentaa kehon kokonaiskuormitusta varsinkin, jos taustalla on jo valmiiksi stressaava arki.
                Tätä on yleensä vaikea ymmärtää, koska kunnon rääkki tuo niin hyvän fiiliksen. Liikunnan vaikutus
                elimistön stressitilaan ei ole aivan yksiselitteinen myöskään sen takia, että olemme kaikki erilaisia ja
                reagoimme tilanteisiin hyvin yksilöllisesti. Onkin hyvä aika ajoin pohtia ja kysellä itseltä, tuoko
                esimerkiksi treenaaminen elämään virkeyttä ja iloa, vai suorituspaineita ja huonoa omaatuntoa.</p>

            <p>On vaarallista verrata itseään muihin. Silti teemme sitä jatkuvasti. Peilaamme itseämme nykyään yhä
                enemmän muiden ulkoiseen malliin. Esimerkiksi sosiaalinen media luo elämästä hyvin pintapuolisen kuvan.
                Vertaamme kokemuksiamme muiden kokemuksiin. Keräämme tavoitteita ja ihanteita muualta sen sijaan, että
                pohtisimme, mikä on juuri minulle tärkeää. Tunnemme helposti riittämättömyyttä, kun näemme muiden
                julkisivun. Näin kasaamme itsellemme taakan, jota emme jaksa kantaa.</p>

            <p>Eri tilanteet, tapahtumat ja asiat sinänsä eivät aiheuta stressiä, vaan ne ovat aina yksilöstä
                riippuvaisia. Stressi syntyy meidän yksilöllisistä reaktioistamme tilanteisiin. Toiset reagoivat
                voimakkaammin niin iloon kuin suruun. Myös oma olotila vaikuttaa; esimerkiksi väsyneenä on vaikeampi
                sietää vastoinkäymisiä. Omien tuntemusten kuulostelu ei ole lainkaan pahasta, ja sille olisi hyvä antaa
                aikaa. Oman kehon viestejä voi opetella kuuntelemaan. Valitettavasti usein huomaamme kehon avunhuudot
                vasta, kun jotain pysäyttävää tapahtuu.</p>

            <p>Itse kantapään kautta oppineena voin sanoa, että tie hyvään oloon lähtee armollisuudesta itseä ja muita
                kohtaan. Aina ei jaksa, eikä se haittaa. Kroppa toimii parhaiten, kun ravinto, liikunta ja lepo ovat
                tasapainossa, ja tekemisessä on ilo ja riemu mukana. Lepo ei tarkoita pelkästään unta eikä palautumista
                treeneistä, vaan myös sitä, että annetaan mielen toipua rasituksesta. Kehomme on kuitenkin
                psykofyysinen kokonaisuus.</p>

            <p>Uuteen vuoteen pitää aina asettaa tavoitteita. Ne rytmittävät mukavasti elämää, mutta kannattaa välillä
                pysähtyä kuuntelemaan itseä. Onko vuosi 2017 täynnä vaatimuksia vai mahdollisuuksia?</p>

            <p>Iida</p>

        </article>


        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='stressitomasti-tuloksiin' title='Stressittömästi tuloksiin' titlePic='riippumatto.jpg' blogDate='' firstPara=' Meillä kaikilla on jokin syy motivaattorina, minkä vuoksi treenaamme - jos ja kun treenaamme. Jos haluat näkyviä tuloksia , tai vaikka treenaisit vain omaksi iloksesi tai puolisosi käskystä, kannattaa tämä lukea.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='nilkan-liikkuvuus-ja-huolto-osa1' title='Nilkan liikkuvuus ja huolto' titlePic='nilkat.jpg' blogDate='' firstPara='Levytangolla tehtävistä kyykkyliikkeistä etu- ja takakyykky ovat ne tunnetuimmat ja tehokkaimmat versiot. Olen viimeisinä vuosina yrittänyt tehdä selkäni vuoksi enemmän etukyykkyä kuin takakyykkyä, sillä etukyykky on selälle kevyempi vaihtoehto.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen hyödyntämiseen' titlePic='2014/etunojapunnerrus2.jpg' blogDate='' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.'></BlogSummary>
                </article>
            </div>
        </section>
    </div>
{/if}

<style>


</style>